//import { IGridStrategy, HeaderGridStrategy, PageGridStrategy, FooterGridStrategy } from './index';

import { type IGridStrategy } from './abstract.strategy';
import { HeaderGridStrategy } from './header.strategy';
import { PageGridStrategy } from './page.strategy';
import { FooterGridStrategy } from './footer.strategy';

import { EventEmitter } from '../../../system/classes/event-emitter';

export class CommonGridStrategy extends EventEmitter implements IGridStrategy {
    private strategy: IGridStrategy;

    constructor(strategy: IGridStrategy) {
        super();
        this.strategy = new FooterGridStrategy(new PageGridStrategy(new HeaderGridStrategy(strategy)));
    }

    public getGridHeight(): number {
        return this.strategy.getGridHeight();
    }

    public getInnerGridHeight(): number {
        return this.strategy.getInnerGridHeight();
    }

    public getGridPageAmount(): number {
        return this.strategy.getGridPageAmount();
    }

    public showPagination() {
        return this.strategy.showPagination();
    }

    public addHeader(headerHeight = 0): void {
        this.strategy.addHeader(headerHeight);
    }

    public on(event, listener, options = null) {
        return this.strategy.on(event, listener, options);
    }

    public getCssClasses() {
        return this.strategy.getCssClasses();
    }

    public isStretchable(): boolean {
        return this.strategy.isStretchable();
    }

    public usesAllItems(): boolean {
        return this.strategy.usesAllItems();
    }

    public detach() {
        this.strategy.detach();
    }

    public setGridElement(gridElement: HTMLElement): void {
        this.strategy.setGridElement(gridElement);
    }
}
